var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSaudiArabia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.25 75C58.9607 75 75.75 58.2107 75.75 37.5C75.75 16.7893 58.9607 0 38.25 0C17.5393 0 0.75 16.7893 0.75 37.5C0.75 58.2107 17.5393 75 38.25 75Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9458 44.8369C21.9458 47.5382 24.1357 49.7282 26.8371 49.7282H41.511C41.511 51.9793 43.3359 53.8042 45.5871 53.8042H50.4783C52.7295 53.8042 54.5544 51.9793 54.5544 49.7282V44.8369H21.9458Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9621 21.1958V32.6088C54.9621 34.4069 53.4993 35.8697 51.7012 35.8697V40.761C56.1963 40.761 59.8533 37.1039 59.8533 32.6088V21.1958H54.9621Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9079 32.6086C19.9079 34.4067 18.4451 35.8695 16.647 35.8695V40.7607C21.1421 40.7607 24.7991 37.1036 24.7991 32.6086V21.1956H19.9079V32.6086Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.625 21.1958H52.5163V32.6088H47.625V21.1958Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.288 27.7173C40.288 28.1669 39.9223 28.5325 39.4729 28.5325C39.0234 28.5325 38.6577 28.1667 38.6577 27.7173V21.1956H33.7664V27.7173C33.7664 28.1669 33.4006 28.5325 32.9512 28.5325C32.5018 28.5325 32.136 28.1667 32.136 27.7173V21.1956H27.2446V27.7173C27.2446 30.864 29.8046 33.4239 32.9512 33.4239C34.1631 33.4239 35.2869 33.0431 36.2121 32.3962C37.1372 33.0429 38.2611 33.4239 39.473 33.4239C39.717 33.4239 39.957 33.4068 40.193 33.3768C39.8464 34.8048 38.5603 35.8695 37.0273 35.8695V40.7607C41.5225 40.7607 45.1794 37.1036 45.1794 32.6086V27.7173V21.1956H40.2882V27.7173H40.288Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2446 35.8696H34.5816V40.7609H27.2446V35.8696Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSaudiArabia);
export default __webpack_public_path__ + "static/media/flagSaudiArabia.cc7656e9f42982ae6110e40fea001cb4.svg";
export { ForwardRef as ReactComponent };